<cyborg-section-nav id="dashboard-nav">
  <hyperkit-tab-bar variant="secondary" mode="underline">
    <hyperkit-tab text="Emerging Threats" [selected]="true">
      <cyborg-emerging></cyborg-emerging>
    </hyperkit-tab>
    <hyperkit-tab text="Recently Updated">
      <cyborg-hunt-packages></cyborg-hunt-packages>
    </hyperkit-tab>
    <hyperkit-tab text="My Environment">
      <cyborg-my-env></cyborg-my-env>
    </hyperkit-tab>
    <hyperkit-tab (click)="hideFilterPane()" text="MITRE">
      <cyborg-mitre></cyborg-mitre>
    </hyperkit-tab>
  </hyperkit-tab-bar>
</cyborg-section-nav>
